import { Component } from "react";
import BCService from "../../../services/BC";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../../services/SellingService";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";

// original import UploadFileService from "../../../services/UploadFileService";

class PayementBCEspece extends Component {
  state = {
    amount: 0,
    fileName: "Ticket de caisse",
    selectedFile: null,
    urlFile: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      fileName: "Ticket de caisse",
      selectedFile: null,
      urlFile: "",
    };
    this.changeAmount = this.changeAmount.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
  }

  changeAmount(event) {
    this.setState({ amount: event.target.value });
  }

  refreshPage() {
    window.location.reload(false);
  }

  onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      this.setState({
        fileName: event.target.files[0].name,
      });
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    }
  };

  payerBill = (e) => {
    if (this.state.amount === "") {
      toast.error("Erreur : le champ montant  est vide");
    } else {
      let payFactureOrAvance = {
        idUser: getCurrentUserId(),
        isFactureOrBDC: 0,
        idDocument: parseInt(localStorage.getItem("idBC")),
        isAvanceOrTotalPayement: 0,
        typePayement: 0,
        ammountPayed: this.state.amount,
        urlFile: "any",
        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
      };

      // if (this.state.selectedFile != null) {
      //   const uploadData = new FormData();
      //   uploadData.append("picture", this.state.selectedFile);

      //   UploadAndDownloadService.uploadFile(
      //     "/retail/uploadFile/uploadFile/Payement",
      //     uploadData
      //   )
      //     .then((response) => {
      //       if (response.data["success"]) {
      //         payFactureOrAvance.urlFile = response.data.success;

      //       } else {
      //         toast.error("Erreur : il ya un probléme au niveau de serveur");
      //       }
      //     })
      //     .catch(() => {
      //       toast.error("Erreur : il ya un probléme de connection");
      //     });

      //   e.preventDefault();
      // } else {
      if (localStorage.getItem("isIncome") === "ACHAT") {
        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      } else if (localStorage.getItem("isIncome") === "VENTE") {
        SellingService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      }
      // }
    }
  };
  render() {
    return (
      <div className="box-body">
        {/* <br />
        <br /> */}
        {/* <label>Charger la ticket de caisse </label> */}
        <br />
        <ToastContainer />

        <div class="row">
          <div class="col-md-3">
            <div className="form-group">
              <label>Montant : </label>
              <input
                className="form-control"
                placeholder="Montant"
                name="amount"
                type="number"
                value={this.state.amount}
                onChange={this.changeAmount}
              />
            </div>
          </div>

          <div class="col-md-9">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={2} />
          </div>
        </div>

        <div class="box-footer">
          <button
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementBCEspece;
